import React, { useRef, useState } from "react";
import dynamic from "next/dynamic";
import VillaTypeTitle from "./VillaTypeTitle";

const VillaTypeList = dynamic(() => import("./VillaTypeList"), { ssr: false });

const VillaTypeDropdown = ({ setShowTips, showTips, tips }) => {
  const refOne = useRef(null);
  const [tipOptions, setTipOptions] = useState([]);

  const handleShowTips = () => {
    setShowTips(!showTips);
  };

  return (
    <div
      ref={refOne}
      className="relative w-full mb-2 lg:w-1/4 xsm:w-1/2 lg:mb-0"
    >
      <VillaTypeTitle handleShowTips={handleShowTips} tipOptions={tipOptions} />
      {showTips && (
        <VillaTypeList
          refOne={refOne}
          tips={tips}
          showTips={showTips}
          setShowTips={setShowTips}
          tipOptions={tipOptions}
          setTipOptions={setTipOptions}
        />
      )}
    </div>
  );
};

export default VillaTypeDropdown;
